export default "__VITE_ASSET__uvObmXGb__"